import {
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

// Define types for the function parameters
// eslint-disable-next-line sonarjs/redundant-type-aliases -- Disabled for plugin version update. Fix when possible.
type PlanId = number;
// eslint-disable-next-line sonarjs/redundant-type-aliases -- Disabled for plugin version update. Fix when possible.
type PlanCouponId = number;
// eslint-disable-next-line sonarjs/redundant-type-aliases -- Disabled for plugin version update. Fix when possible.
type Source = any; // Replace 'any' with a more specific type if possible

const update = (planId: PlanId, planCouponId: PlanCouponId, source: Source) =>
  reactQueryPut(
    internalApi.AccountSubscriptions.update(planId, planCouponId, source),
  );

const renew = (planId: PlanId) =>
  reactQueryPost(internalApi.AccountSubscriptions.renew(planId));

const canDowngrade = async (
  planId: PlanId,
): Promise<any> => // Replace 'any' with the actual return type
  await reactQueryGet(internalApi.AccountSubscriptions.canDowngrade(planId));

const createEmailHubSubscription = (): Promise<any> => // Replace 'any' with the actual return type
  reactQueryPost(internalApi.AccountSubscriptions.createEmailHubSubscription());

const reactivateEmailHubSubscription = (): Promise<any> => // Replace 'any' with the actual return type
  reactQueryPost(
    internalApi.AccountSubscriptions.reactivateEmailHubSubscription(),
  );

export const accountSubscriptionApi = {
  update,
  renew,
  canDowngrade,
  createEmailHubSubscription,
  reactivateEmailHubSubscription,
};
